import { gql, useQuery } from "@apollo/client";

export const CreateClients = gql`
	mutation CreateClients(
		$name: String!
		$email: String
		$addressInfo: AddressInfoInput
		$localidade: String
		$phoneNumber: String
		$nif: String
		$avatar: String
	) {
		createDefaultUser(
			input: {
				name: $name
				email: $email
				addressInfo: $addressInfo
				localidade: $localidade
				phoneNumber: $phoneNumber
				nif: $nif
				avatar: $avatar
			}
		) {
			_id
			name
			email
			dob
			createdAt
		}
	}
`;
